import layoutAdmin from "@/layouts/layoutAdmin.vue";
import addProject from "@/views/module/project/projectManagement/addProject.vue";
import projectList from "@/views/module/cms/project/projectList.vue";
import cmsDocumentRecord from '@/views/module/cms/documentManagement/cmsDocumentRecord.vue';
import cmsFolderRecord from '@/views/module/cms/folderManagement/cmsFolderRecord.vue';
import cmsTransmittalEntry from '@/views/module/cms/transmittalManagement/cmsTransmittalEntry.vue';
import cmsTransmittalRecord from '@/views/module/cms/transmittalManagement/cmsTransmittalRecord.vue';
import transmittalView from '@/views/module/cms/transmittalManagement/transmittalView.vue';
import approvalRequestList from "@/views/module/accounts/journalVoucher/approvalRequestList.vue";
import journalVoucherApprovalPreview from "@/views/module/accounts/journalVoucher/approvalPreview.vue";
import journalVoucherApprovalDetails from "@/views/module/accounts/journalVoucher/approvalDetails.vue";
import cmsDepartmentSetup from '@/views/module/cms/department/departmentSetup.vue';
import cmsArchiveList from '@/views/module/cms/archive/archiveList.vue';
import projectSendMail from "@/views/module/project/mailManagement/projectSendMail.vue";

export default 
[
    {
        path:'/cms',
        component: layoutAdmin,
        meta:{
            UserLoggedIn: true,
            breadcrumb: "CMS Management"
        },
        children: [
             {
                path: "add-project",
                name: "add-project",
                meta: {
                    breadcrumb: ['Add Project']
                },
                component: addProject,
            },
            {
                path: "project-list",
                name: "project-list",
                meta : {
                    breadcrumb: ['Project List']
                },
                component: projectList,
            },
            {
                path: "folders",
                name: "cms-folder",
                meta: {
                    breadcrumb: ['CMS Management', 'Folder']
                },
                component: cmsFolderRecord,
            },
            {
                path: "document",
                name: "cms-document",
                meta: {
                    breadcrumb: ['CMS Management', 'Document']
                },
                component: cmsDocumentRecord,
            },
            {
                path: "department",
                name: "cms-department",
                meta: {
                    breadcrumb: ['CMS Management', 'Department']
                },
                component: cmsDepartmentSetup,
            },
            {
                path: "archive",
                name: "cms-archive",
                meta: {
                    breadcrumb: ['CMS Management', 'Archive']
                },
                component: cmsArchiveList,
            },

            // CMS Management - Folder
            {
                path: "folders",
                name: "cms-folder",
                meta: {
                    breadcrumb: ['CMS Management', 'Folder']
                },
                component: cmsFolderRecord,
            },

            {
                path: "transmittal",
                name: "transmittal",
                meta: {
                    breadcrumb: ['CMS Management', 'Transmittal']
                },
                component: cmsTransmittalEntry,
            },

            {
                path: "transmittal-list",
                name: "transmittal-list",
                meta: {
                    breadcrumb: ['CMS Management', 'Transmittal List']
                },
                component: cmsTransmittalRecord,
            },

            {
                path: "transmittal-view/:id",
                name: "transmittal-view",
                meta: {
                    breadcrumb: ['CMS Management', 'Transmittal View']
                },
                component: transmittalView,
            },
            {
                path: "approval-request-record",
                name: "approval-request-record",
                meta: {
                breadcrumb: ["CMS Management", "Document Request List"],
                },
                component: approvalRequestList,
            },
            {
                path: "approval-process-preview/:id",
                name: "approval-process-preview",
                meta: {
                breadcrumb: ["CMS Management", "Document Preview"],
                },
                component: journalVoucherApprovalPreview,
            },
            {
                path: "approval-process-details/:id",
                name: "approval-process-details",
                meta: {
                breadcrumb: ["CMS Management", "Approval Detail"],
                },
                component: journalVoucherApprovalDetails,
            },
            {
                path: "send-mail",
                name: "send-mail",
                meta: {
                    breadcrumb: ['Send Mail']
                },
                component: projectSendMail,
            },
    ]
    }
]

